import { render, staticRenderFns } from "./FlexSpinner.vue?vue&type=template&id=2aeac62a"
import script from "./FlexSpinner.vue?vue&type=script&lang=js"
export * from "./FlexSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports